






import Rule from '../atoms/Rule.vue'
import { RuleInterface } from '../../../types'
import Vue from 'vue'

export default Vue.extend({
  name: 'Rules',

  components: { Rule },

  props: {
    rules: {
      required: true,
      type: Array as () => Array<RuleInterface>
    }
  },

  methods: {
    setKey(rule: RuleInterface) {
      return rule.numbers.toString().replace(/,/g, '')
    }
  }
})
